
// import React, { useRef, useState, useEffect } from "react";
// import {
//   Input,
//   Upload,
//   Button,
//   Row,
//   Col,
//   Checkbox,
//   Card,
//   Typography,
//   Space,
// } from "antd";
// import {
//   UploadOutlined,
//   FilePdfOutlined,
// } from "@ant-design/icons";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import { QRCodeCanvas } from "qrcode.react";
// import { Editor } from "@tinymce/tinymce-react";

// const CertificateGenerator = ({ studentName, courseTitle }) => {
//   const certRef = useRef(null);

//   const [qrLink, setQrLink] = useState("");
//   const [logoPreview, setLogoPreview] = useState(null);
//   const [backgroundPreview, setBackgroundPreview] = useState(null);
//   const [backgroundColor, setBackgroundColor] = useState("#ffffff");
//   const [textColor, setTextColor] = useState("#000000");
//   const [useImageBackground, setUseImageBackground] = useState(false);
//   const [paddingTop, setPaddingTop] = useState(40);
//   const [paddingBottom, setPaddingBottom] = useState(40);
//   const [logoTopSpacing, setLogoTopSpacing] = useState(30);
//   const [logoMarginBottom, setLogoMarginBottom] = useState(20);
//   const [logoWidth, setLogoWidth] = useState(100);
//   const [logoHeight, setLogoHeight] = useState(100);
//   const [backgroundWidth, setBackgroundWidth] = useState(650);
//   const [backgroundHeight, setBackgroundHeight] = useState(610);

//   useEffect(() => {
//     const safeStudent = (studentName || "").replace(/\s+/g, "-").toLowerCase();
//     const safeCourse = (courseTitle || "").replace(/\s+/g, "-").toLowerCase();
//     const randomCode = Math.floor(1000 + Math.random() * 9000);
//     setQrLink(`https://nomidya.com/cert/${safeStudent}-${safeCourse}-${randomCode}`);
//   }, [studentName, courseTitle]);

//   const [certificateHtmlContent, setCertificateHtmlContent] = useState(`
//     <h1 style="text-align:center;">Certificat de réussite</h1>
//     <p>Ce certificat est décerné à :</p>
//     <h2 style="font-weight:bold;">${studentName}</h2>
//     <p>pour avoir complété le cours :</p>
//     <h3 style="font-style:italic;">${courseTitle}</h3>
//     <br/>
//     <p>_________________________</p>
//     <p>Formateur</p>
//     <p style="text-align:center;">Fait le : ${new Date().toLocaleDateString()}</p>
//   `);

//   const handleImageUpload = (info, setState) => {
//     const file = info.file?.originFileObj || info.file;
//     const url = URL.createObjectURL(file);
//     setState(url);
//   };

//   const generatePDF = () => {
//     html2canvas(certRef.current).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("landscape", "pt", "a4");
//       pdf.addImage(imgData, "PNG", 0, 0, 842, 595);
//       pdf.save(`${studentName}_certificat.pdf`);
//     });
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <Card title="Paramètres du certificat" size="small" style={{ marginBottom: 16 }}>
//         <Space wrap size="small" style={{ width: '100%' }}>
//           <Upload showUploadList={false} customRequest={({ file }) => handleImageUpload({ file }, setLogoPreview)}>
//             <Button icon={<UploadOutlined />}>Logo</Button>
//           </Upload>
//           <Input type="number" min={30} value={logoWidth} onChange={(e) => setLogoWidth(Number(e.target.value))} suffix="px" style={{ width: 80 }} />
//           <Input type="number" min={30} value={logoHeight} onChange={(e) => setLogoHeight(Number(e.target.value))} suffix="px" style={{ width: 80 }} />

//           <Upload showUploadList={false} customRequest={({ file }) => handleImageUpload({ file }, setBackgroundPreview)}>
//             <Button icon={<UploadOutlined />}>Image de fond</Button>
//           </Upload>
//           <Checkbox checked={useImageBackground} onChange={(e) => setUseImageBackground(e.target.checked)}>Utiliser</Checkbox>
//           <Input type="number" min={100} value={backgroundWidth} onChange={(e) => setBackgroundWidth(Number(e.target.value))} suffix="px" style={{ width: 100 }} />
//           <Input type="number" min={100} value={backgroundHeight} onChange={(e) => setBackgroundHeight(Number(e.target.value))} suffix="px" style={{ width: 100 }} />

//           <Input type="color" value={textColor} onChange={(e) => setTextColor(e.target.value)} title="Couleur texte" />
//           <Input type="color" value={backgroundColor} onChange={(e) => setBackgroundColor(e.target.value)} title="Couleur fond" />

//           <Input type="number" value={logoTopSpacing} onChange={(e) => setLogoTopSpacing(Number(e.target.value))} suffix="px" title="Haut logo" style={{ width: 100 }} />
//           <Input type="number" value={logoMarginBottom} onChange={(e) => setLogoMarginBottom(Number(e.target.value))} suffix="px" title="Esp. logo-titre" style={{ width: 100 }} />

//           <Input type="number" value={paddingTop} onChange={(e) => setPaddingTop(Number(e.target.value))} suffix="px" title="Padding haut" style={{ width: 100 }} />
//           <Input type="number" value={paddingBottom} onChange={(e) => setPaddingBottom(Number(e.target.value))} suffix="px" title="Padding bas" style={{ width: 100 }} />
//         </Space>
//         <div style={{ marginTop: 10 }}>
//           <Typography.Text code>QR Code Link :</Typography.Text> <Typography.Text copyable>{qrLink}</Typography.Text>
//         </div>
//       </Card>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Editor
//             apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//             value={certificateHtmlContent}
//             init={{
//               height: 700,
//               menubar: true,
//               plugins: ["link", "lists", "table", "paste", "code", "help"],
//               toolbar:
//                 "undo redo | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | code",
//             }}
//             onEditorChange={(content) => setCertificateHtmlContent(content)}
//           />
//         </Col>
//         <Col span={12}>
//           <div
//             ref={certRef}
//             style={{
//               width: `${backgroundWidth}px`,
//               height: `${backgroundHeight}px`,
//               paddingTop: `${paddingTop}px`,
//               paddingBottom: `${paddingBottom}px`,
//               paddingLeft: "40px",
//               paddingRight: "40px",
//               background: useImageBackground ? `url(${backgroundPreview}) center/cover no-repeat` : backgroundColor,
//               color: textColor,
//               borderRadius: "16px",
//               position: "relative",
//               boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//             }}
//           >
//             {logoPreview && (
//               <img
//                 src={logoPreview}
//                 alt="Logo"
//                 style={{
//                   position: "absolute",
//                   top: `${logoTopSpacing}px`,
//                   left: "30px",
//                   width: `${logoWidth}px`,
//                   height: `${logoHeight}px`,
//                 }}
//               />
//             )}

//             <div style={{ marginTop: `${logoTopSpacing + logoHeight + logoMarginBottom}px` }}>
//               <div dangerouslySetInnerHTML={{ __html: certificateHtmlContent }} />
//             </div>

//             <div style={{ position: "absolute", bottom: "30px", right: "30px" }}>
//               <QRCodeCanvas value={qrLink} size={80} bgColor="white" fgColor="#000" />
//             </div>
//           </div>
//         </Col>
//       </Row>

//       <Button
//         type="primary"
//         icon={<FilePdfOutlined />}
//         onClick={generatePDF}
//         style={{ marginTop: 20 }}
//       >
//         Télécharger le certificat
//       </Button>
//     </div>
//   );
// };

// export default CertificateGenerator;
import React, { useRef, useState, useEffect } from "react";
import {
  Input,
  Upload,
  Button,
  Row,
  Col,
  Checkbox,
  Card,
  Typography,
  Space,
  message
} from "antd";
import {
  UploadOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import { Editor } from "@tinymce/tinymce-react";

const CertificateGenerator = ({ studentName, courseTitle }) => {
  const certRef = useRef(null);

  const [qrLink, setQrLink] = useState("");
  const [logoPreview, setLogoPreview] = useState(null);
  const [backgroundPreview, setBackgroundPreview] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");
  const [textColor, setTextColor] = useState("#000000");
  const [useImageBackground, setUseImageBackground] = useState(false);
  const [paddingTop, setPaddingTop] = useState(40);
  const [paddingBottom, setPaddingBottom] = useState(40);
  const [logoTopSpacing, setLogoTopSpacing] = useState(30);
  const [logoMarginBottom, setLogoMarginBottom] = useState(20);
  const [logoWidth, setLogoWidth] = useState(100);
  const [logoHeight, setLogoHeight] = useState(100);
  const [backgroundWidth, setBackgroundWidth] = useState(650);
  const [backgroundHeight, setBackgroundHeight] = useState(610);

  useEffect(() => {
    const safeStudent = (studentName || "").replace(/\s+/g, "-").toLowerCase();
    const safeCourse = (courseTitle || "").replace(/\s+/g, "-").toLowerCase();
    const randomCode = Math.floor(1000 + Math.random() * 9000);
    setQrLink(`https://nomidya.com/cert/${safeStudent}-${safeCourse}-${randomCode}`);
  }, [studentName, courseTitle]);

  const [certificateHtmlContent, setCertificateHtmlContent] = useState("");

  useEffect(() => {
    const today = new Date().toLocaleDateString();
    setCertificateHtmlContent(`
      <h1 style=\"text-align:center;\">Certificat de réussite</h1>
      <p>Ce certificat est décerné à :</p>
      <h2 style=\"font-weight:bold;\">${studentName}</h2>
      <p>pour avoir complété le cours :</p>
      <h3 style=\"font-style:italic;\">${courseTitle}</h3>
      <br/>
      <p>_________________________</p>
      <p>Formateur</p>
      <p style=\"text-align:center;\">Fait le : ${today}</p>
    `);
  }, [studentName, courseTitle]);

  const handleImageUpload = (info, setState) => {
    const file = info.file?.originFileObj || info.file;
    const url = URL.createObjectURL(file);
    setState(url);
  };

  const generatePDF = async () => {
    try {
      const canvas = await html2canvas(certRef.current);
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "pt", "a4");
      pdf.addImage(imgData, "PNG", 0, 0, 842, 595);
      const safeStudent = (studentName || "").replace(/\s+/g, "_");
      pdf.save(`${safeStudent}_certificat.pdf`);
    } catch (error) {
      console.error("Erreur lors de la génération du PDF :", error);
      message.error("Une erreur est survenue lors du téléchargement du certificat.");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <Card title="Paramètres du certificat" size="small" style={{ marginBottom: 16 }}>
        <Space wrap size="small" style={{ width: '100%' }}>
          <Upload showUploadList={false} customRequest={({ file }) => handleImageUpload({ file }, setLogoPreview)}>
            <Button icon={<UploadOutlined />}>Logo</Button>
          </Upload>
          <Input type="number" min={30} value={logoWidth} onChange={(e) => setLogoWidth(Number(e.target.value))} suffix="px" style={{ width: 80 }} />
          <Input type="number" min={30} value={logoHeight} onChange={(e) => setLogoHeight(Number(e.target.value))} suffix="px" style={{ width: 80 }} />

          <Upload showUploadList={false} customRequest={({ file }) => handleImageUpload({ file }, setBackgroundPreview)}>
            <Button icon={<UploadOutlined />}>Image de fond</Button>
          </Upload>
          <Checkbox checked={useImageBackground} onChange={(e) => setUseImageBackground(e.target.checked)}>Utiliser</Checkbox>
          <Input type="number" min={100} value={backgroundWidth} onChange={(e) => setBackgroundWidth(Number(e.target.value))} suffix="px" style={{ width: 100 }} />
          <Input type="number" min={100} value={backgroundHeight} onChange={(e) => setBackgroundHeight(Number(e.target.value))} suffix="px" style={{ width: 100 }} />

          <Input type="color" value={textColor} onChange={(e) => setTextColor(e.target.value)} title="Couleur texte" />
          <Input type="color" value={backgroundColor} onChange={(e) => setBackgroundColor(e.target.value)} title="Couleur fond" />

          <Input type="number" value={logoTopSpacing} onChange={(e) => setLogoTopSpacing(Number(e.target.value))} suffix="px" title="Haut logo" style={{ width: 100 }} />
          <Input type="number" value={logoMarginBottom} onChange={(e) => setLogoMarginBottom(Number(e.target.value))} suffix="px" title="Esp. logo-titre" style={{ width: 100 }} />

          <Input type="number" value={paddingTop} onChange={(e) => setPaddingTop(Number(e.target.value))} suffix="px" title="Padding haut" style={{ width: 100 }} />
          <Input type="number" value={paddingBottom} onChange={(e) => setPaddingBottom(Number(e.target.value))} suffix="px" title="Padding bas" style={{ width: 100 }} />
        </Space>
        <div style={{ marginTop: 10 }}>
          <Typography.Text code>QR Code Link :</Typography.Text> <Typography.Text copyable>{qrLink}</Typography.Text>
        </div>
      </Card>

      <Row gutter={16}>
        <Col span={12}>
          <Editor
            apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
            value={certificateHtmlContent}
            init={{
              height: 600,
              menubar: true,
              plugins: ["link", "lists", "table", "paste", "code", "help"],
              toolbar:
                "undo redo | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | code",
            }}
            onEditorChange={(content) => setCertificateHtmlContent(content)}
          />
        </Col>
        <Col span={12}>
          <div
            ref={certRef}
            style={{
              width: `${backgroundWidth}px`,
              height: `${backgroundHeight}px`,
              paddingTop: `${paddingTop}px`,
              paddingBottom: `${paddingBottom}px`,
              paddingLeft: "40px",
              paddingRight: "40px",
              background: useImageBackground ? `url(${backgroundPreview}) center/cover no-repeat` : backgroundColor,
              color: textColor,
              borderRadius: "16px",
              position: "relative",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            }}
          >
            {logoPreview && (
              <img
                src={logoPreview}
                alt="Logo"
                style={{
                  position: "absolute",
                  top: `${logoTopSpacing}px`,
                  left: "30px",
                  width: `${logoWidth}px`,
                  height: `${logoHeight}px`,
                }}
              />
            )}

            <div style={{ marginTop: `${logoTopSpacing + logoHeight + logoMarginBottom}px` }}>
              <div dangerouslySetInnerHTML={{ __html: certificateHtmlContent }} />
            </div>

            <div style={{ position: "absolute", bottom: "30px", right: "30px" }}>
              <QRCodeCanvas value={qrLink} size={80} bgColor="white" fgColor="#000" />
            </div>
          </div>
        </Col>
      </Row>

      <Button
        type="primary"
        icon={<FilePdfOutlined />}
        onClick={generatePDF}
        style={{ marginTop: 20 }}
      >
        Télécharger le certificat
      </Button>
    </div>
  );
};

export default CertificateGenerator;
